var map = {
	"./Ancient Blue Dragon.png": 1762,
	"./Ancient Green Dragon.png": 1763,
	"./Ancient Red Dragon.png": 1764,
	"./Ancient Yellow Dragon.png": 1765,
	"./Bandit.png": 1766,
	"./Beb.png": 1767,
	"./Black Dragon.png": 1768,
	"./Blue Dragon.png": 1769,
	"./Bone Snake.png": 1770,
	"./Bunny.png": 1771,
	"./Cactuson King.png": 1772,
	"./Cactuson.png": 1773,
	"./Catson Archer.png": 1774,
	"./Catson Guard.png": 1775,
	"./Catson King.png": 1776,
	"./Catson.png": 1777,
	"./Cave Goblin Trapper.png": 1778,
	"./Cave Goblin.png": 1779,
	"./Ceb.png": 1780,
	"./Chicken.png": 1781,
	"./Chucken.png": 1782,
	"./Clay Golem.png": 1783,
	"./Crablante.png": 1784,
	"./Crossbow Tigerman.png": 1785,
	"./Cultist.png": 1786,
	"./Cursed Yeti.png": 1787,
	"./Damascus Dragon.png": 1788,
	"./Dead Eye Jones.png": 1789,
	"./Deb.png": 1790,
	"./Dehydrated Cactuson.png": 1791,
	"./Demon Prince.png": 1792,
	"./Demonic Bunny.png": 1793,
	"./Dwarf Guard.png": 1794,
	"./Dwarf.png": 1795,
	"./Earth Elemental.png": 1796,
	"./Earth Slime.png": 1797,
	"./Easter Bunny.png": 1798,
	"./Enraged Cactuson.png": 1799,
	"./Fairy King.png": 1800,
	"./Fairy Knight.png": 1801,
	"./Fairy Queen.png": 1802,
	"./Fairy Rider.png": 1803,
	"./Fairy Warrior.png": 1804,
	"./Fairy.png": 1805,
	"./Fire Demon.png": 1806,
	"./Fire Elemental.png": 1807,
	"./Fire Giant.png": 1808,
	"./Fire Slime.png": 1809,
	"./Fire Snake.png": 1810,
	"./Flowering Cactuson.png": 1811,
	"./Forest Demon.png": 1812,
	"./Frogman Ambassador.png": 1813,
	"./Frogman Archer.png": 1814,
	"./Frogman King.png": 1815,
	"./Frogman Mage.png": 1816,
	"./Frogman Warrior.png": 1817,
	"./Frogman.png": 1818,
	"./Frost Demon.png": 1819,
	"./Frost Giant.png": 1820,
	"./Giant Bear.png": 1821,
	"./Giant Skeleton.png": 1822,
	"./Giant Spider.png": 1823,
	"./Glitch Hop the Buggy.png": 1824,
	"./Goat King.png": 1825,
	"./Goatman.png": 1826,
	"./Goblin Berserker.png": 1827,
	"./Goblin Champion.png": 1828,
	"./Goblin King.png": 1829,
	"./Goblin Swashbuckler.png": 1830,
	"./Goblin Warrior.png": 1831,
	"./Goblin.png": 1832,
	"./Greater Earth Slime.png": 1833,
	"./Greater Fire Slime.png": 1834,
	"./Greater Lightning Slime.png": 1835,
	"./Greater Slime.png": 1836,
	"./Greater Water Slime.png": 1837,
	"./Greater Wind Slime.png": 1838,
	"./Green Dragon.png": 1839,
	"./Guard.png": 1840,
	"./Hat Demon.png": 1841,
	"./Highwayman.png": 1842,
	"./Jaime Goliver.png": 1843,
	"./Lesser Demon.png": 1844,
	"./Lesser Earth Slime.png": 1845,
	"./Lesser Fire Slime.png": 1846,
	"./Lesser Lightning Slime.png": 1847,
	"./Lesser Slime.png": 1848,
	"./Lesser Water Slime.png": 1849,
	"./Lesser Wind Slime.png": 1850,
	"./Lieutenant Cae.png": 1851,
	"./Lieutenant Cra.png": 1852,
	"./Lieutenant Pom.png": 1853,
	"./Lightning Slime.png": 1854,
	"./Man.png": 1855,
	"./Money Bags.png": 1856,
	"./Mutated Frogman.png": 1857,
	"./Mutated Hydra.png": 1858,
	"./Orc Archer.png": 1859,
	"./Orc Berserker.png": 1860,
	"./Orc King.png": 1861,
	"./Orc Shaman.png": 1862,
	"./Orc War Chief.png": 1863,
	"./Orc Warrior.png": 1864,
	"./Orc.png": 1865,
	"./Owlman Archer.png": 1866,
	"./Owlman King.png": 1867,
	"./Owlman Sage.png": 1868,
	"./Owlman Warrior.png": 1869,
	"./Owlman.png": 1870,
	"./Phoenix.png": 1871,
	"./Psychic Orc.png": 1872,
	"./Punk.png": 1873,
	"./Rat.png": 1874,
	"./Ratman Berserker.png": 1875,
	"./Ratman Guard.png": 1876,
	"./Ratman King.png": 1877,
	"./Ratman.png": 1878,
	"./Red Dragon.png": 1879,
	"./Sand Demon.png": 1880,
	"./Science Punk.png": 1881,
	"./Skelly Spider.png": 1882,
	"./Slime.png": 1883,
	"./Small Bone Snake.png": 1884,
	"./Storm Giant.png": 1885,
	"./Swamp Demon.png": 1886,
	"./The Jealous Witch.png": 1887,
	"./Tigerman Archer.png": 1888,
	"./Tigerman Captain.png": 1889,
	"./Tigerman Fighter.png": 1890,
	"./Tigerman King.png": 1891,
	"./Tigerman.png": 1892,
	"./Tikitama.png": 1893,
	"./Tortoise.png": 1894,
	"./Unicorn.png": 1895,
	"./Utalagu.png": 1896,
	"./Water Elemental.png": 1897,
	"./Water Slime.png": 1898,
	"./Wind Elemental.png": 1899,
	"./Wind Slime.png": 1900,
	"./Wolfman.png": 1901,
	"./Woman.png": 1902,
	"./Yellow Dragon.png": 1903,
	"./Zenitsu.png": 1904,
	"./Zombie.png": 1905,
	"./Zorgling.png": 1906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1761;